import React, { useState, useEffect } from 'react';
import qs from 'querystringify';
import { config as AuthConfig } from '@commaai/my-comma-auth';
import { auth as AuthApi } from '@commaai/comma-api';

import './App.css';

function App() {
  const [ jwtToken, setJwtToken ] = useState(null);
  const [ apiErr, setApiErr ] = useState(null);
  let params = qs.parse(window.location.search);
  let pathname = window.location.pathname;

  useEffect(function() {
    console.log(pathname, params);
    if (apiErr === null && jwtToken === null && pathname === AuthConfig.AUTH_PATH && params.code && params.provider) {
      AuthApi.refreshAccessToken(params.code, params.provider).then(function(jwtToken) {
        setJwtToken(jwtToken);
      }).catch(function(err) {
        setApiErr(err);
      })
    }
  });

  const script = document.createElement("script");
  document.body.appendChild(script);
  script.onload = () => {
    window.AppleID.auth.init({
      clientId : AuthConfig.APPLE_CLIENT_ID,
      scope : AuthConfig.APPLE_SCOPES,
      redirectURI : AuthConfig.APPLE_REDIRECT_URI,
      state: AuthConfig.APPLE_STATE,
    });
  };
  script.src = "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";
  script.async = true;
  document.addEventListener('AppleIDSignInOnSuccess', (data) => {
    window.location = [AuthConfig.APPLE_REDIRECT_PATH,
      qs.stringify({code: data.detail.authorization.code})].join('?');
  });

  if (params.code) {
    if (apiErr !== null) {
      return (<div>Error: { apiErr.message }) <a href="/">Try Again</a></div>);
    } else if(jwtToken === null) {
      return (<div>Loading...</div>);
    } else {
      return (<div><label for="jwt">JWT: <input name="jwt" type="text" size="64" value={ jwtToken } /></label></div>);
    }
  } else {
    return (
      <div className="App">
        <p><a href={ AuthConfig.GOOGLE_REDIRECT_LINK }>Sign in with Google</a></p>
        <p><a href="#" onClick={ () => { window.AppleID.auth.signIn() } }>Sign in with Apple</a></p>
        <p><a href={ AuthConfig.GITHUB_REDIRECT_LINK }>Sign in with GitHub</a></p>
      </div>
    );
  }
}

export default App;
